var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 9.28566V72.1428C80 76.8767 76.1625 80.7142 71.4286 80.7142H8.57143C3.8375 80.7142 0 76.8767 0 72.1428V9.28566C0 4.55173 3.8375 0.714233 8.57143 0.714233H71.4286C76.1625 0.714233 80 4.55173 80 9.28566ZM64.2857 12.1428H44.2909C40.485 12.1428 38.5623 16.7608 41.2604 19.4591L46.9718 25.171L12.0563 60.0866C11.2195 60.9233 11.2195 62.2801 12.0563 63.1171L17.5971 68.658C18.4341 69.4948 19.7909 69.4948 20.6277 68.658L55.543 33.7426L61.2552 39.4553C63.9389 42.1387 68.5714 40.2544 68.5714 36.4248V16.4285C68.5714 14.0616 66.6527 12.1428 64.2857 12.1428Z",
    fill: "#D2A500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0916f4c153388cfe68cb391a3a68aa9c.svg";
export { ForwardRef as ReactComponent };